{
	"title": "Proiecte",
	"table": {
		"reference": "Referință",
		"quantity": "Cantitate totală",
		"savings": "Reduceri totale de CO\u2082",
		"fetchError": "Nu s-au putut prelua proiectele"
	},
	"showProjectsHistoryTitle": "Afișează istoricul proiectelor",
	"noProjects": {
		"createDeclaration": "Creează prima ta declarație",
		"description": "Puteți crea declarații pentru unul sau mai multe materiale făcând clic pe „Creează declarație”."
	}
}
